import React, { useState, useRef, useEffect } from 'react';
import styles from './TooltipBottom.module.css';

const TooltipBottom = ({
  text,
  children,
  link,
  backgroundColor,
  onHoverChange,        /* (isHovered: boolean) => void - handler to execute any side effects on hover change */
  enableTooltipHoverEffect = false
}) => {
  const [hovered, setHovered] = useState(false);
  const [isTooltipTextHovered, setIsTooltipTextHovered] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState({});
  const [arrowStyle, setArrowStyle] = useState({});
  const tooltipRef = useRef(null);
  const hideTimer = useRef(null);

  const showTooltip = () => {
    clearTimeout(hideTimer.current);
    setHovered(true);
    if (onHoverChange) {
      onHoverChange(true);
    }
  };

  const hideTooltip = () => {
    hideTimer.current = setTimeout(() => {
      setHovered(false)
      if (onHoverChange) {
         onHoverChange(false)
      }
    }, 150);
  };

  useEffect(() => {
    return () => clearTimeout(hideTimer.current);
  }, []);

  useEffect(() => {
    if (hovered && tooltipRef.current) {
     
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const { innerWidth } = window;
      const offset = 8;

      // Our base style positions the tooltip below the element.
      // We add a small vertical offset so it doesn't overlap the text.
      let newStyle = {
        left: '50%',
        transform: 'translateX(-50%)',
        top: 'calc(100% + 10px)'  // <-- Nudge the tooltip further down.
      };

      let newArrowStyle = {
        left: '50%',
        transform: 'translateX(-50%)'
      };

      let shiftX = 0;
      if (tooltipRect.left < offset) {
        shiftX = offset - tooltipRect.left;
      } else if (tooltipRect.right > innerWidth - offset) {
        shiftX = -(tooltipRect.right - (innerWidth - offset));
      }

      newStyle.transform = `translateX(calc(-50% + ${shiftX}px))`;
      let arrowShiftX = -shiftX;
      newArrowStyle.transform = `translateX(calc(-50% + ${arrowShiftX}px))`;

      setTooltipStyle(newStyle);
      setArrowStyle(newArrowStyle);
    } else {
      setTooltipStyle({});
      setArrowStyle({});
    }
  }, [hovered]);

  const getTooltipStyles = () => {
    if (enableTooltipHoverEffect && isTooltipTextHovered) {
      // Darken the background color on hover while retaining the original background color for the border
      const borderColor = backgroundColor || '#32363D'
      return {
        '--tooltip-bg': '#202020', 
        '--tooltip-arrow-bg': borderColor,
        '--tooltip-border-width': '4px', 
        border: `4px solid ${borderColor}`, // Border using default tooltip bg color
        padding: '2px 6px'
      };
    }
    // Otherwise, maintain default styling
    return {
      '--tooltip-bg': backgroundColor, 
      '--tooltip-arrow-bg': backgroundColor,
      '--tooltip-border-width': '0px'
    };
  };

  return (
    <div
      className={styles.tooltipWrapper}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}

      {hovered && (
        <div
          className={styles.tooltip}
          ref={tooltipRef}
          style={{
            ...tooltipStyle,
            ...getTooltipStyles()
          }}
        >
          <div
            onMouseEnter={() => setIsTooltipTextHovered(true)}
            onMouseLeave={() => setIsTooltipTextHovered(false)}    
          >
            {text}
          </div>
          {link && (
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className={styles.learnMoreLink}
            >
              Learn More
            </a>
          )}
          <div className={styles.arrow} style={arrowStyle} />
        </div>
      )}
    </div>
  );
};

export default TooltipBottom;